import {FC, useMemo} from 'react';
import {Editor as EditorComponent, EditorProps as EditorComponentProps} from '@memaro/slate'
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';

type EditorProps = EditorComponentProps & {
    editMode: boolean
}

const StyledBox = styled(Box)({
    textAlign: 'justify',
    ':focus': {
        outline: 0,
    },
    '.editable': {
        textAlign: 'justify',
        ':focus': {
            outline: 0,
        }
    }
})

const EditableBox: FC<EditorProps> = ({editMode, contents, ...props}) => {
    const innerHTML = useMemo(() => ({
        __html: contents ?? ""
    }), [contents])

    return editMode ? (
        <StyledBox>
            <EditorComponent contents={contents} {...props} />
        </StyledBox>
    ) : (
        <StyledBox dangerouslySetInnerHTML={innerHTML}/>
    )
}

export default EditableBox;
